<td class="mat-mdc-cell">
    <span>{{ rigthName }}</span>
</td>
<td class="mat-mdc-cell mat-mdc-cell-action">
    @if (rightId) {
        @if (disabled) {
            <span>
                @if (rightControl.value) {
                    <mat-icon class="">done</mat-icon>
                }
            </span>
        } @else {
            <div class="checkbox-editor">
                <mat-checkbox class="accent-button" [formControl]="rightControl" (change)="checkboxChanged(rightId, $event)"></mat-checkbox>
            </div>
        }
    }
</td>
